var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { getSearchStart, getSearchSucceeded, getSearchFailed, } from "./system.actions";
import { GENERATOR_PARAMS } from "./system.constants";
var getExtraDefaultState = function () { return ({
    search: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(getSearchStart.type, function (state, payload) {
    var _a;
    var _b, _c, _d;
    var resultsExists = !!((_d = (_c = (_b = state.search) === null || _b === void 0 ? void 0 : _b[payload.identifier]) === null || _c === void 0 ? void 0 : _c.results) === null || _d === void 0 ? void 0 : _d.length);
    return __assign(__assign({}, state), { search: __assign(__assign({}, state.search), (_a = {}, _a[payload.identifier] = __assign(__assign({}, state.search[payload.identifier]), { isFetching: !resultsExists, fetchError: undefined }), _a)) });
});
reducer.on(getSearchSucceeded.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { search: __assign(__assign({}, state.search), (_a = {}, _a[payload.identifier] = __assign(__assign({}, state.search[payload.identifier]), { results: payload.data, isFetching: false, fetchError: undefined }), _a)) });
});
reducer.on(getSearchFailed.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { search: __assign(__assign({}, state.search), (_a = {}, _a[payload.identifier] = __assign(__assign({}, state.search[payload.identifier]), { isFetching: false, fetchError: payload.error }), _a)) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
